import { debounce, isPlainObject } from 'lodash'
import { enforceUnit } from '../../utils'
import '../../style/row-cell.scss'
const className = 'virtual-grid__inner__table__row__cell'
const _customRenderCellClass = 'cell__custom-render'
const _rowCellCanSelectedClass = 'row-cell-can-selectd'

function getCellClass ({rowCellCanSelected, rowIndex, columnIndex, rowData, column, cellClassName, customRenderCell, headerAlign} = {}) {
  const classes = [
    className,
  ]
  if (customRenderCell) classes.push(_customRenderCellClass)
  if (rowCellCanSelected) classes.push(_rowCellCanSelectedClass)
  if (column.className) classes.push(column.className)
  if (column.rowCellRender && column.showOverflowTooltip) {
    classes.push('cell-wrap-padding-6')
  }
  const align = column.align || column.textAlign || headerAlign
  if (align) {
    classes.push(`${className}__${align}`)
  }
  if (typeof cellClassName === 'string') {
    classes.push(cellClassName)
  } else if (typeof cellClassName === 'function') {
    const val = cellClassName({
      rowIndex,
      columnIndex,
      row: rowData,
      column
    })
    if (Array.isArray(val)) {
      classes.push(...val)
    } else {
      classes.push(val)
    }
  }
  return classes.filter(Boolean)
}

function eventsFactory (h, {
  handleEvent,
  rowData,
  rowIndex,
  column,
  value,
  renderDataIndex,
  columnIndex
}) {
  // 事件
  const cellMouseout = function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, eventType: 'mouse-out', execRow: false, event, columnIndex })
  }
  const cellMousemove = debounce(function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, eventType: 'mouse-move', execRow: false, event, columnIndex })
  }, 50)
  const cellMouseenter = function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, eventType: 'mouse-enter', execRow: false, event, columnIndex, value })
  }
  const cellMousedown = debounce(function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, eventType: 'mouse-down', execRow: false, event, columnIndex })
  }, 50)
  const cellMouseleave = function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, eventType: 'mouse-leave', execRow: false, event, columnIndex })
  }
  const cellClick = function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, renderDataIndex, eventType: 'click', event, columnIndex })
  }

  function cellDblclick(event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, value, renderDataIndex, eventType: 'dblclick', event, columnIndex })
  }

  const contextmenu = function (event) {
    handleEvent && handleEvent(event, { rowData, rowIndex, column, eventType: 'contextmenu', event, columnIndex, value })
  }

  return {
    contextmenu,
    mouseout: cellMouseout,
    mousemove: cellMousemove,
    mouseenter: cellMouseenter,
    mousedown: cellMousedown,
    mouseleave: cellMouseleave,
    click: cellClick,
    dblclick: cellDblclick,
  }
}


function getCellStyle({
  rowIndex,
  columnIndex,
  rowData,
  column,
  cellStyle,
  rowspan = 1,
  rowHeight,
  enableDynamicHeight,
  isFooter
  // lastRowColIndexIsMerged
} = {}) {
  let _cellStyle = {}
  if (!enableDynamicHeight) {
    // 如果是合并的则需要处理高度
    let _height = isFooter ? rowHeight : rowHeight * rowspan
    _cellStyle = {
      height: _height + 'px', // 不允许超过或等于rowHeight。否则会错位。
    }
    if (cellStyle && isPlainObject(cellStyle)) {
      _cellStyle = {
        ...cellStyle,
        ..._cellStyle
      }
    }
  }
  if (typeof cellStyle === 'function') {
    const useCellStyle = cellStyle({
      rowIndex,
      columnIndex,
      row: rowData,
      column
    }) || {}
    if (useCellStyle && isPlainObject(useCellStyle)) {
      _cellStyle = {
        ...useCellStyle,
        ..._cellStyle
      }
    }
  }
  if (parseInt(column.width)) {
    _cellStyle.width = parseInt(column.width) + 'px' // 解决windows环境不会自动继承td的宽度，导致会出现width有小数点问题
  }
  return enforceUnit(_cellStyle || {})
}

export function createCellContentWrap () {
  return {
    functional: true,
    render (h, context) {
      const {
        rowData,
        rowIndex,
        column,
        columnIndex,
        cellClassName,
        cellStyle,
        rowHeight,
        rowspan,
        enableDynamicHeight,
        headerAlign,
        rowCellCanSelected,
        isFooter
      } = context.props
      const { rowCellRenderToLeft, rowCellRenderToRight } = column
      const slots = context.slots().default || []
      const childrenVnode = [...slots]
      if (rowCellRenderToLeft) {
        childrenVnode.unshift(rowCellRenderToLeft(h, context.props, context))
      }
      if (rowCellRenderToRight) {
        childrenVnode.push(rowCellRenderToRight(h, context.props, context))
      }
      // 样式
      const className = getCellClass({
        rowIndex,
        columnIndex,
        rowData,
        column,
        cellClassName,
        customRenderCell: !!column.rowCellRender,
        headerAlign,
        rowCellCanSelected
      })
      const style = getCellStyle({
        rowIndex,
        columnIndex,
        rowData,
        column,
        cellStyle,
        rowHeight,
        rowspan,
        enableDynamicHeight,
        isFooter
      })
      const on = eventsFactory(h, context.props)
      return h('div', {
        on,
        class: className,
        style,
        attrs: {
          'data-column-key': column.key
        }
      }, childrenVnode)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/body/cell-content-wrap.js